import React from 'react'
import { Select, Input  } from 'antd';

const { Option } = Select;
const { TextArea } = Input;
function handleChange(value) {
  console.log(`selected ${value}`);
}

function Guarantor() {
	
  return (
  <>
    <div className='container'>
	<label class='subtext-2'>First name</label>
	<Input placeholder="Enter first name" style={{ width: '100%', height: 50, border: '1px solid #333333', borderRadius: 10 }} bordered={false} />
	
	<br /><br />
    <label class='subtext-2'>Last name</label>
	<Input placeholder="Enter last name" style={{ width: '100%', height: 50, border: '1px solid #333333', borderRadius: 10 }} bordered={false} />
	
	<br /><br />
    <label class='subtext-2'>Phone</label>
	<Input placeholder="Enter phone number" style={{ width: '100%', height: 50, border: '1px solid #333333', borderRadius: 10 }} bordered={false} />
	
	<br /><br />
    <label class='subtext-2'>Email</label>
	<Input placeholder="Enter email address" style={{ width: '100%', height: 50, border: '1px solid #333333', borderRadius: 10 }} bordered={false} />
	
	<br /><br />
    <label class='subtext-2'>Guarantor occupation</label>
	<Input placeholder="" style={{ width: '100%', height: 50, border: '1px solid #333333', borderRadius: 10 }} bordered={false} />
	
	<br /><br />
    <label class='subtext-2'>Guarantor address</label>
	<Input placeholder="" style={{ width: '100%', height: 50, border: '1px solid #333333', borderRadius: 10 }} bordered={false} />
	
	<br /><br />
    </div>
	
	</>
  )
}

export default Guarantor